import type {Logger} from './types';

export class ConsoleLogger implements Logger {
    // eslint-disable-next-line no-console
    trace = console.trace;
    // eslint-disable-next-line no-console
    debug = console.debug;
    // eslint-disable-next-line no-console
    info = console.info;
    // eslint-disable-next-line no-console
    warn = console.warn;
    // eslint-disable-next-line no-console
    error = console.error;
}